import { Button, Col, Form, Input, notification, Popconfirm, Row, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { addMeasurementsUnitApi, listOfMeasurementsUnitApi, updateMeasurementsUnitApi } from "../../../../../config/Api";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE } from "../../../../../config/constant";
export const MeasurementsUnit = () => {
    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [MeasurementsUnitsData, setMeasurementsUnitsData] = useState()
    const [editMeasurementsUnitRecord, setEditMeasurementsUnitRecord] = useState()
    const [loading, setLoading] = useState(false)

    const [form] = Form.useForm();

    // get the list of alll available plans 
    const getListOfMeasurementsUnit = () => {
        setLoading(true)

        listOfMeasurementsUnitApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // call when user click on edit
    const editMeasurementsUnit = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'name': data.name })
        setEditMeasurementsUnitRecord(data);
    }

    useEffect(() => {
        getListOfMeasurementsUnit()
    }, []);

    // filter data according to user search input 
    useEffect(() => {
        filterMeasurementsUnit(MeasurementsUnitsData);
    }, [MeasurementsUnitsData]);

    // filter recipe category
    const filterMeasurementsUnit = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.name.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    // update status of recipe category
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;

        updateMeasurementsUnitApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Measurement Unit Update successfully",
                    });
                    getListOfMeasurementsUnit()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };

    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "name": values.name,
                "status": true
            }
            addMeasurementsUnitApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'name': '' })
                        notification.success({
                            message: "Measurement Unit added successfully",
                        });
                        getListOfMeasurementsUnit()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "name": values.name,
                "status": values.status
            }
            updateMeasurementsUnitApi(editMeasurementsUnitRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "Measurement Unit Update successfully",
                        });
                        getListOfMeasurementsUnit()
                        form.setFieldsValue({ 'name': '' })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editMeasurementsUnit(record) }} className="me-2" />
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];
    const data = [
        {
            id: '1',
            name: 'cm',
            status: true
        },
        {
            id: '2',
            name: 'in',
            status: false
        },
        {
            id: '3',
            name: 'kg',
            status: true
        },
        {
            id: '4',
            name: 'mg/dL',
            status: true
        },
        {
            id: '5',
            name: 'ug/dL',
            status: true
        }
    ];

    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="MeasurementsUnit">
            <Row>
                <Col xl={14}>
                    <Form
                        name="addMeasurementsUnitForm"
                        // className="addDiseasesForm"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row className="addMeasurementsUnitForm">
                            <Col xl={8}>
                                <Form.Item
                                    name="name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Unit Name!",
                                        },
                                        // {
                                        //     pattern: CHARACTER_PATTERN,
                                        //     message: CHARACTER_PATTERN_MESSAGE,
                                        // }
                                    ]}
                                >
                                    <Input placeholder="Enter Unit Name" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={8}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2" icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />}
                                >
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
                <Col xl={4} className="text-end align-self-center">
                    <h6>Total :  {displayData.length > 0 ? displayData.length : 0} </h6>
                </Col>
                <Col xl={6} className="align-self-center">
                    <Input.Search placeholder="Search Measurement Unit"
                        onChange={(e) => { filterMeasurementsUnit(e.target.value); setMeasurementsUnitsData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Table
                        columns={columns}
                        rowKey="id"
                        dataSource={displayData}
                        // pagination={false}
                        scroll={{ x: "max-content" }}
                        className="w-100"
                    />
                </Row>
            </Spin>
        </div>
    )
}
